import { FormattedMessage } from 'react-intl'
import { Button, Modal, ModalBody, ModalFooter, Progress } from 'reactstrap'

const PMBProgressBarExportFile = (props) => {
  const { isDialogShow, firstRows = 0, totalRows = 0, onCancel } = props
  return (
    <Modal
      isOpen={isDialogShow}
      className="modal-lg modal-dialog-centered"
      placement="top"
      target="center"
      size="md"
      data-testid="pmb-progress-bar-export-modal"
    >
      <ModalBody>
        {isDialogShow && (
          <div className="mt-2">
            <div className="text-center" data-testid="pmb-progress-bar-export-percent">
              {firstRows === 0 && totalRows === 0
                ? 0
                : Math.floor((firstRows / totalRows) * 100)}
              %
            </div>
            <div>
              <Progress
                value={Math.floor((firstRows / totalRows) * 100)}
                animated
                data-testid="pmb-progress-bar-export-progress"
              />
            </div>
          </div>
        )}
      </ModalBody>

      <ModalFooter>
        <Button
          color="primary"
          onClick={() => onCancel()}
          data-testid="pmb-progress-bar-export-cancel"
        >
          Batal
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default PMBProgressBarExportFile
